import styles from './section.module.css'
import { ReactNode, useState } from 'react'

type Props = {
    id: string
    title?: ReactNode
    // Título alternativo al desplegar: permite ocultar badges que ya se ven en el contenido.
    titleExpanded?: ReactNode
    children?: JSX.Element | JSX.Element[]
    headerActions?: JSX.Element[]
    defaultExpanded?: boolean
    collapsable?: boolean
    space?: number
    framed?: boolean
    smallFont?: boolean
    className?: string
}

export const Section = (props: Props) => {
    const { id, title, titleExpanded, children, headerActions, defaultExpanded, collapsable, space, framed = true, smallFont, className } = props
    const [expanded, setExpanded] = useState<boolean>(defaultExpanded || (!collapsable && !!children) || false)
    const [hasBeenExpanded, setHasBeenExpanded] = useState<boolean>(expanded)

    const expand = () => {
        const next = !expanded
        setExpanded(next)
        if (next) setHasBeenExpanded(true)
    }

    const headerId = `${id}-header`
    const collapseId = `${id}-collapse`
    const propClass = className || ''
    const expandedClass = expanded ? styles.expanded : ''
    const frameClass = framed ? styles.framed : ''
    const smallFontClass = smallFont ? styles.smallFont : ''

    const stopPropagation = (event: React.MouseEvent) => event.stopPropagation()

    const renderHeaderActions = () => headerActions && headerActions.length > 0 && (
        <div className={styles.headerActions} onClick={stopPropagation}>
            {headerActions}
        </div>
    )

    const renderHeaderEnd = () => (
        <div className={styles.headerEnd}>
            {renderHeaderActions()}
            {collapsable && (
                <i className={`bi bi-chevron-down ${styles.expandIcon} ${expandedClass}`}></i>
            )}
        </div>
    )

    return (
        <div className={`accordion-flush col-sm-${space || 10} ${propClass} ${styles.container} ${expandedClass} ${frameClass}`} id={id}>
            <div className={`accordion-item ${styles.content}`}>
                {collapsable && (
                    <div
                        id={headerId}
                        className={`accordion-header ${styles.header} ${expandedClass} ${frameClass}`}
                        data-bs-target={`#${collapseId}`}
                        aria-expanded={expanded}
                        aria-controls={collapseId}
                        onClick={expand}
                    >
                        <span>{expanded && titleExpanded !== undefined ? titleExpanded : (title || (expanded ? 'Colapsar' : 'Expandir'))}</span>
                        {renderHeaderEnd()}
                    </div>
                )}
                {!collapsable && (
                    <div className={`accordion-header ${styles.header} ${frameClass}`}>
                        {title && <span>{title}</span>}
                        {renderHeaderActions()}
                    </div>
                )}
                <div id={collapseId} className={`accordion-collapse collapse ${expanded ? 'show' : ''}`} aria-labelledby={headerId} data-bs-parent={`#${id}`}>
                    <div className={`accordion-body ${smallFontClass}`}>
                        {hasBeenExpanded && children}
                    </div>
                </div>
            </div>
        </div>
    )
}
